import React, { useContext, useState } from "react";

export class ReactException extends eXpress.Exception {
	public componentStack: string;

	constructor(error: unknown, componentStack: string) {
		super(eXpress.Exception.getMessage(error));
		this.componentStack = componentStack;
	}
}

interface IErrorContext {
	blockingError: unknown;
	setBlockingError(error: unknown): void;
}

const ErrorContext = React.createContext<IErrorContext>({} as IErrorContext);
ErrorContext.displayName = "ErrorContext";

/** A context containing the blocking error */
export function ErrorContextProvider(props: React.PropsWithChildren) {
	const { children } = props;

	const [blockingError, setBlockingError] = useState(undefined);

	// return as an object instead of an error
	const errorContext = {
		// No need for useMemo
		blockingError,
		setBlockingError,
	};

	// Make errorContext available on console in 'Debug' mode
	// Assuming only one context is used, else global variable overridden
	if (eXpress.isDebugMode) {
		// Allow, this is only used for debugging
		// eslint-disable-next-line react-compiler/react-compiler
		(window as any)._errorContext = errorContext;
	}

	return <ErrorContext.Provider value={errorContext}>{children}</ErrorContext.Provider>;
}
ErrorContextProvider.displayName = "ErrorContextProvider";

/** Create Hook to get the error context */
export const useErrorContext = () => useContext(ErrorContext);
